import type { LicensePlate } from '@navio/nsdk';
import { NoddiTooltip } from 'noddi-ui-web';
import { getCarDisplayName, pluralize } from 'noddi-util';
import { CarWithSalesItemsInfo } from '../CarDetails/Cards/CarWithSalesItemsInfo';

type BookingCar = {
  id: number;
  licensePlate: LicensePlate;
  make: string;
  model: string;
  orderLines?: { id: number; description: string }[];
};

type Props = {
  bookingCars: BookingCar[];
  carId: number;
};

export const WheelSetBookingCars = ({ bookingCars, carId }: Props) => {
  const car = bookingCars.find((bookingCar) => bookingCar.id === carId);
  if (!car) {
    return null;
  }

  const otherCars = bookingCars.filter((bookingCar) => bookingCar.id !== carId);

  return (
    <CarWithSalesItemsInfo
      licensePlate={car.licensePlate}
      carDisplayName={getCarDisplayName({ car, showLicensePlate: false, showYear: false })}
      salesItems={car.orderLines?.map((orderLine) => ({ id: orderLine.id, name: orderLine.description })) ?? []}
      footer={
        otherCars.length > 0 && (
          <NoddiTooltip
            trigger={
              <span className='text-xs text-muted-foreground underline decoration-dotted'>
                +{otherCars.length} more {pluralize(otherCars.length, 'car')} on this booking
              </span>
            }
            content={
              <div className='flex flex-col gap-0.5 text-xs'>
                {otherCars.map((otherCar) => (
                  <span key={otherCar.id}>{getCarDisplayName({ car: otherCar, showYear: false })}</span>
                ))}
              </div>
            }
          />
        )
      }
    />
  );
};
